import { type FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { LayoutBlock } from 'shared/components/LayoutBlock';
import { Banner } from 'shared/components/Promos';
import { trackPromoBannerClick } from 'shared/components/Promos/Banner/internal/tracking/trackPromoBannerClick';
import { mortgageBannerSelector } from 'shared/selectors/mortgageBanner';

import { trackShowPromosSection } from './internal/tracking/trackShowPromosSection';

export const Promos: FC = () => {
  const banner = useSelector(mortgageBannerSelector);

  const handleBannerClick = useCallback(() => {
    trackPromoBannerClick();
  }, []);

  if (!banner?.image) {
    return null;
  }

  return (
    <LayoutBlock id="promos" onView={trackShowPromosSection}>
      <Banner
        disclaimer={banner.disclaimer}
        hitUrl={banner.hitUrl}
        image={banner.image}
        key={0}
        onBannerClick={handleBannerClick}
      />
    </LayoutBlock>
  );
};
